import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../actions';

import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
// import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import { withTranslation } from 'react-i18next';

import Stepper0 from './stepper0';
import {Stepper1, Stepper2, Stepper3} from './stepper1';
import Stepper5 from './stepper5';
import Stepper4 from './stepper4';
import StepperResult from './stepper_result';
import NeedToCollectMail from './need_to_collect_mail';
import {ButtonReset} from './button_validation';


const styles = theme => ({
  root: {
    width: '100%',
  },
  instructions: {
    fontWeight: 'bolder',
  },
});

function getSteps(year, t) {
  if (year){
    return [t('label_main_data'), year, year-1, year-2, t('real_estate'), t('financy')];  
  }
  return [t('label_main_data'), '', '', '', t('real_estate'), t('financy')];
}

function GetStepContent(props) {
  const {activeStep, onSubmit_lastStep, ...others} = props; 
  switch (activeStep) {
    case 0:
      return <Stepper0 {...props} />;
    case 1:
      return <Stepper1 {...props} index={2}/>;
    case 2:
      return <Stepper2 {...props} index={3} />;
    case 3:
      return <Stepper3 {...props} index={4} />;
    case 4:
      return <Stepper5 {...props} index={4} />;
    case 5:
      return <Stepper4 
      {...others}
      activeStep = {activeStep}
      onSubmit = {onSubmit_lastStep} />;
    default:
      return <div>Unknown step</div>;
  }
}


class Steppers extends React.Component {
  state = {
    showModal: false
  };

  isStepFailed = step => {
    return step === -1;
  };

  updateActiveStep = id => {
    this.props.estimation_update_step(id);
  }

  handleNext = () => {
    const { activeStep } = this.props;
    this.updateActiveStep(activeStep + 1 );
  };

  onSubmit_lastStep = () => {
    this.setState({showModal: true});
  };

  onSubmit_callAPI_isLogged = () => {
    const { formUse, formMail } = this.props;
    this.setState({showModal: false});
    this.handleNext(); 
    this.props.estimationCompute(formUse, formMail);     
  };

  handleBack = () => {
    const { activeStep } = this.props;
    this.updateActiveStep(activeStep -1 );
  };

  handleReset = () => {
    this.updateActiveStep(0);
  };

  modalOpen = () => {
    this.setState({ showModal: true });
  };

  modalClose = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { showModal } = this.state;
    const { classes, formUse, enterpriseValue, activeStep, t } = this.props;
    var latestYear = false;
    var currency = null;

    if (formUse && formUse.values){
      if(formUse.values.latestYear && formUse.values.latestYear.value){
        latestYear = formUse.values.latestYear.value;
      }
      if(formUse.values.currency && formUse.values.currency.value){
        currency = formUse.values.currency.value;
      }  
    }
    const steps = getSteps(latestYear, t);

    return (
      <div className={classes.root}>
        <NeedToCollectMail 
          showModal={showModal}
          modalOpen = {this.modalOpen}
          modalClose = {this.modalClose}
          onSubmit_isLogged={this.onSubmit_callAPI_isLogged}
        />
        <Stepper 
          activeStep={activeStep} 
          alternativeLabel>
          {steps.map((label, index) => {
            const props = {};
            const labelProps = {};
            if (this.isStepFailed(index)) {
              labelProps.error = true;
            }
            return (
              <Step key={label} {...props}>
                <StepLabel {...labelProps}>
                  <Hidden xsDown> {label} </Hidden>
                  <Hidden xsUp> {''} </Hidden>
                </StepLabel>
              </Step>
            );         
           })}
       
        </Stepper>
        <div>
          {activeStep === steps.length ? (
            <div>
              <Typography className={classes.instructions} variant='h5'>
                {t('email_final_message')}
              </Typography>
              <StepperResult 
                {...this.props}
                enterpriseValue ={enterpriseValue}
                currency ={currency}
                />

              <ButtonReset 
              handleReset={this.handleReset}
              handleBack = {this.handleBack}
               />
            </div>
          ) : (
            <div>
              <GetStepContent
                activeStep = {activeStep} 
                handleBack = {this.handleBack}
                steps = {steps}
                onSubmit={this.handleNext}
                onSubmit_lastStep={this.onSubmit_lastStep}
              />

            </div>
          )}
        </div>
      </div>
    );
  }
}

Steppers.propTypes = {
  classes: PropTypes.object,
};

Steppers =  withStyles(styles)(Steppers);

function mapStateToProps(state){
  return { 
    formUse: state.form.formEstimation,
    formMail: state.form.formEstimationMail,
    activeStep: state.estimation.activeStep,
    enterpriseValue: state.estimation.enterpriseValue,
  };
}

export default connect(mapStateToProps, actions)(withTranslation()(Steppers));